module.exports = __webpack_public_path__ + "img/hittribe.da1f08cc.svg";